// Shared screening-status helper. Single source of truth for the
// "overdue / due soon / up to date / never logged" classification used by
// the Health Screenings card and (soon) the Annual Wellness Summary PDF.

import type { HealthScreeningRow } from "@/lib/screenings.functions";

export type ScreeningStatus = "overdue" | "due_soon" | "up_to_date" | "never_logged";

export function statusFor(row: HealthScreeningRow | undefined | null): ScreeningStatus {
  if (!row || !row.next_due_date) return "never_logged";
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const due = new Date(row.next_due_date + "T00:00:00");
  const diffDays = Math.round((due.getTime() - today.getTime()) / 86400000);
  if (diffDays < 0) return "overdue";
  if (diffDays <= 60) return "due_soon";
  return "up_to_date";
}
